import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { Text } from '@catalogo/theme-text';

const CollapseText = ({ text, maxTextLength, defaultTextHeight, onChange = null }) => {
  const [collapseActive, setCollapseActive] = useState(true);
  const label = collapseActive ? 'ver mais' : 'ver menos';
  const textRef = useRef();

  const clickCollapseActive = () => {
    setCollapseActive(!collapseActive);

    if (onChange) {
      onChange(collapseActive);
    }
  };

  if (text.length > maxTextLength) {
    return (
      <>
        <TextUI
          active={collapseActive}
          ref={textRef}
          dynamicHeight={collapseActive ? defaultTextHeight : textRef.current.scrollHeight}
        >
          {text}
        </TextUI>
        <ViewMore onClick={clickCollapseActive}>{label}</ViewMore>
      </>
    );
  }

  return (
    <>
      <TextUI>{text}</TextUI>
    </>
  );
};

export default CollapseText;

const TextUI = styled(Text)`
  line-height: 1.5;
  margin-bottom: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  transition: height 250ms ease;
  height: ${({ dynamicHeight }) => `${dynamicHeight}px`};
  -webkit-line-clamp: ${({ active }) => (active ? 3 : 'none')};
`;

const ViewMore = styled.button`
  padding: 0;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 15px;
  margin-top: 8px;
  background: none;
  width: max-content;
  color: ${({ theme }) => theme.primaryColor};
`;
